/**
 * Shared content control modifier utilities.
 * Extracted from ContentControl.ts to break circular dependency
 * with ContentControlHelper.ts.
 */

export async function modifyCannotDelete(
  context: Word.RequestContext,
  cc: Word.ContentControl,
  value: boolean
): Promise<void> {
  if (!cc) {
    console.warn("[modifyCannotDelete] Content Control is not available");
    return;
  }

  try {
    // we read the content controls from the range because reading them directly from the cc is not reliable after clear operation
    // reading from the range, include also the current cc
    const rangeContentControls = cc.getRange().contentControls;
    rangeContentControls.load("items/id");
    await context.sync();

    console.debug(`[modifyCannotDelete] Setting cannotDelete=${value} to CC with id=${cc.id}`);
    cc.cannotDelete = value;

    // we filter the current cc, to get only its children
    const innerContentControls = rangeContentControls.items
      .filter((item) => item.id !== cc.id)
      .map((item) => context.document.contentControls.getById(item.id));

    console.debug(`[modifyCannotDelete] CC with id=${cc.id} has ${innerContentControls.length} child`);

    for (const innerCc of innerContentControls) {
      innerCc.cannotDelete = value;
    }
    await context.sync();
  } catch (error) {
    console.error("[modifyCannotDelete] Error modifying cannotDelete:", error);
  }
}
